import { Badge } from 'foundations-components/transitional/components/Badge';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardInlineLabel = ({
  tooltipProps,
  inlineLabelBadgeText,
  dataTestId
}) => {
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    placement: "bottom"
  }, tooltipProps, {
    children: /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        marginBlockStart: "25",
        children: inlineLabelBadgeText
      })
    })
  }));
};